<template>
  <div class="indicator">
    <select
      class="indicator_select"
      v-model="selectYear.first"
      @change="changeFirstYear($event)"
    >
      <option
        v-for="item in years"
        :key="item + item"
        :value="item"
      > 
        {{ item }}
      </option>
    </select>

    <select
      v-model="selectYear.second"
      class="indicator_select"
      @change="changeSecondYear($event)"
    >
      <option
        v-for="item in secondYears"
        :key="item + item"
        :value="item"
      >
        {{ item }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  name: "Indicator",
  data () {
    return {
      selectYear: {
        first: 1990,
        second: 2023
      },
      years: [
        1990, 
        1991, 
        1992, 
        1993, 
        1994, 
        1995, 
        1996, 
        1997, 
        1998, 
        1999, 
        2000, 
        2001, 
        2002, 
        2003, 
        2004, 
        2005, 
        2006, 
        2007, 
        2008, 
        2009, 
        2010, 
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023,
        2024,
        2025,
        2026,
        2027,
        2028,
        2029,
        2030
      ]
    }
  },
  computed: {
    secondYears () {
      return this.years.filter(item => item > this.selectYear.first)
    }
  },
  methods: {
    changeFirstYear (event) {
      this.$emit('change-first-year', Number(event.target.value))
    },

    changeSecondYear (event) {
      this.$emit('change-second-year', Number(event.target.value))
    }
  }
}
</script>
<style lang="scss" scoped>
  .indicator {
    @media (max-width: 380px) {
      display: flex;
      flex-direction: column;
    }

    &_select {
      width: 100px;
      background-color: #fff;
      margin-right: 20px;
      padding-left: 5px;
      cursor: pointer;
      font-size: 1rem;

      @media (max-width: 380px) {
        margin-top: 20px;
      }
    }
  }
</style>